export const foodCollectionTypes = ["user", "external"] as const;
